/**
 * Side-by-side product shot: same TENSION Relationship HQ screen labeled for
 * Relationship Intelligence and Conversation Micro-Coach (marketing).
 */
import { cn } from '../ui/utils';

const HQ_IMAGE = '/images/tension-ri-microcoach-hq.png';

type Props = {
  /** Dark mesh (RI feature page) vs light card (Micro-Coach page) */
  variant?: 'dark' | 'light';
  className?: string;
};

export function TensionRiMicroCoachShowcase({ variant = 'dark', className }: Props) {
  const isDark = variant === 'dark';
  const frame = isDark
    ? 'border-white/10 bg-neutral-950/40 ring-white/10'
    : 'border-fuchsia-200/80 bg-white/95 ring-fuchsia-200/40 shadow-md';
  const caption = isDark
    ? 'border-white/10 bg-neutral-950/90 text-[11px] font-bold uppercase tracking-[0.14em] text-violet-200'
    : 'border-fuchsia-100 bg-fuchsia-50/90 text-[11px] font-bold uppercase tracking-[0.14em] text-fuchsia-900';

  return (
    <div className={cn('grid grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-4', className)}>
      <figure className={cn('overflow-hidden rounded-2xl shadow-xl ring-1', frame)}>
        <img
          src={HQ_IMAGE}
          alt="TENSION Relationship HQ on mobile: Relationship Intelligence suite with tension delta and next steps"
          width={720}
          height={1280}
          loading="eager"
          decoding="async"
          className="aspect-[9/16] w-full object-cover object-top sm:aspect-[4/5] md:max-h-[min(420px,52vh)]"
        />
        <figcaption className={cn('border-t px-3 py-2.5 text-center', caption)}>Relationship Intelligence</figcaption>
      </figure>
      <figure className={cn('overflow-hidden rounded-2xl shadow-xl ring-1', frame)}>
        <img
          src={HQ_IMAGE}
          alt="TENSION Relationship HQ on mobile: quick pulse, timeline, and guided tools including Micro-Coach"
          width={720}
          height={1280}
          loading="eager"
          decoding="async"
          className="aspect-[9/16] w-full object-cover object-top sm:aspect-[4/5] md:max-h-[min(420px,52vh)]"
        />
        <figcaption className={cn('border-t px-3 py-2.5 text-center', caption)}>
          Conversation Micro-Coach
        </figcaption>
      </figure>
    </div>
  );
}
